<template>
  <v-overlay
      v-if="gameStatus.buzzIn"
      opacity="0.8"
  >
    <v-card
        class="mx-auto my-1"
        max-width="400"
        elevation="7"
    >
      <v-img
          width="350"
          height="490"
          :src="avatar(gameStatus.contestants[gameStatus.buzzIn].avatar)"
      ></v-img>

      <v-card-title justify="center" class="text-h4">
        {{ gameStatus.contestants[gameStatus.buzzIn].name }}

        <v-btn
            color="red"
            elevation="2"
            fab
            absolute
            top
            right
            v-on:click="dismissBuzzer"
            v-if="admin"
        >
          <v-icon>
            mdi-bell-off
          </v-icon>
        </v-btn>

        <v-btn
            color="red"
            elevation="2"
            fab
            absolute
            left
            small
            v-if="admin && !contestantId && gameStatus.inProgress"
            @click="buzzOut()"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>

        <v-btn
            color="green"
            elevation="2"
            fab
            absolute
            right
            small
            v-if="admin && !contestantId && gameStatus.inProgress"
            @click="correct(gameStatus.buzzIn)"
        >
          <v-icon>
            mdi-check
          </v-icon>
        </v-btn>
      </v-card-title>

    </v-card>
  </v-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BuzzIn',
  computed: mapGetters(['admin', 'contestantId', 'gameStatus']),
  data() {
    return {
      poller: null,
      lastBuzzer: null
    };
  },
  updated() {
    this.setTimer();
    this.ring();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    ...mapActions(['buzzOut', 'addPoint']),
    avatar(avatarId) {
      return './avatar/' + avatarId + '.jpg';
    },
    clearTimer() {
      if (this.poller) {
        clearInterval(this.poller);
        this.poller = null;
      }
    },
    dismissBuzzer() {
      this.clearTimer();
      this.buzzOut();
    },
    setTimer() {
      if (!this.poller && this.gameStatus.buzzIn && !this.gameStatus.inProgress) {
        this.poller = setInterval(this.dismissBuzzer, 2000)
      }
    },
    ring() {
      if (this.gameStatus.buzzIn && this.lastBuzzer != this.gameStatus.buzzIn) {
        const sound = './avatar/' + this.gameStatus.contestants[this.gameStatus.buzzIn].avatar + '.mp3';
        const audio = new Audio(sound);
        audio.play();
      }
      this.lastBuzzer = this.gameStatus.buzzIn;
    },
    correct(contestantId) {
      this.addPoint(contestantId);
      this.dismissBuzzer();
    },
  }
}
</script>
